<template>
  <q-page padding>
    <div class="row q-gutter-sm">
      <div class="col-xs-12 col-sm-8">
        <p class="text-h6 text-weight-bold text-brand-5 titulo-pagina">
          Emitir uma Permissão de Trabalho
        </p>
      </div>
    </div>

    <div class="row col-12 text-brand-5 text-weight-bold">
      <q-form ref="emitirForm">
        <div class="row q-gutter-sm container-input">
          <div class="col-lg-2 col-md-1 col-sm-3 col-xs-3">
            <div class="q-ml-sm titulo-input titulo-input-mobile">Unidade</div>
            <lista-unidades-select
              class="titulo-input-mobile"
              v-model="emitir.unidade"
            ></lista-unidades-select>
          </div>

          <div class="col-lg-2 col-md-1 col-sm-3 col-xs-3">
            <div class="q-ml-sm titulo-input titulo-input-mobile">Modelo</div>
            <q-select
              dense
              outlined
              class="select"
              v-model="emitir.modelo"
              :options="listaModelos"
              :option-label="
                (opt) =>
                  Object(opt) === opt && 'modeloNome' in opt
                    ? opt.modeloNome
                    : ''
              "
              :rules="[(val) => val || 'Campo obrigatório']"
              lazy-rules
            />
          </div>

          <div class="col-lg-2 col-md-1 col-sm-3 col-xs-3">
            <div class="q-ml-sm titulo-input">Data Previsão Emissão</div>
            <q-input
              dense
              outlined
              label="Data e Hora de Início"
              v-model="emitir.dataInicio"
              mask="##/##/#### ##:##"
              fill-mask
              placeholder="DD/MM/AAAA HH:MM"
              :rules="[
                (val) => (val && val.length > 0) || 'Campo obrigatório',
                (val) => validarDataHora(val) || 'Data/hora inválida',
              ]"
              class="input"
            >
              <template v-slot:append>
                <q-btn
                  flat
                  dense
                  icon="event"
                  size="md"
                  @click="abrirSeletorAvancado('inicio')"
                >
                  <q-tooltip>Selecionar data e hora</q-tooltip>
                </q-btn>
              </template>
            </q-input>
          </div>

          <div class="col-lg-2 col-md-1 col-sm-3 col-xs-3">
            <div class="q-ml-sm titulo-input titulo-input-mobile-margin">
              Data Previsão Término
            </div>
            <q-input
              dense
              outlined
              label="Data e Hora de Término"
              v-model="emitir.dataTermino"
              mask="##/##/#### ##:##"
              fill-mask
              placeholder="DD/MM/AAAA HH:MM"
              :rules="[
                (val) => (val && val.length > 0) || 'Campo obrigatório',
                (val) => validarDataHora(val) || 'Data/hora inválida',
                (val) =>
                  validarDataTermino(val) ||
                  'Data término deve ser posterior ao início',
              ]"
              class="input"
            >
              <template v-slot:append>
                <q-btn
                  flat
                  dense
                  icon="event"
                  size="md"
                  @click="abrirSeletorAvancado('termino')"
                >
                  <q-tooltip>Selecionar data e hora</q-tooltip>
                </q-btn>
              </template>
            </q-input>
          </div>
          <div class="col-md-2 col-xs-2 col-sm-8 col-lg-4">
            <div class="q-ml-sm titulo-input titulo-input-mobile-margin">
              Local
            </div>
            <q-select
              dense
              outlined
              class="select"
              v-model="emitir.local"
              :options="listaArea"
              :option-label="
                (opt) => (Object(opt) === opt && 'nome' in opt ? opt.nome : '')
              "
              :rules="[(val) => val || 'Campo Obrigatório']"
            />
          </div>
          <div class="col-lg-5 col-md-5 col-sm-6 col-xs-6">
            <div class="q-ml-sm titulo-input titulo-input-mobile-margin">
              Descrição do Trabalho
            </div>
            <q-input class="input" dense outlined v-model="emitir.descricao" />
          </div>
          <div class="col-lg-2 col-md-3 col-sm-5 col-xs-5">
            <p></p>
            <q-btn
              class="btn-emitir"
              color="positive"
              icon="add"
              label="Emitir a PT"
              type="submit"
              no-caps
              @click.prevent="emitirPt"
            />
          </div>
        </div>
      </q-form>
    </div>
    <div v-if="emitir.longitude && geolocalizacao" class="q-mt-md">
      <Map :long="long" :lat="lat" />
    </div>

    <q-dialog v-model="seletorAvancado.aberto">
      <q-card style="width: 600px; min-width: 45vw">
        <q-card-section>
          <div class="text-h6">
            {{
              seletorAvancado.tipo === "inicio"
                ? "Data/Hora de Início"
                : "Data/Hora de Término"
            }}
          </div>
        </q-card-section>

        <q-card-section class="q-pt-none">
          <div class="q-mb-lg">
            <div class="text-subtitle2 q-mb-sm text-grey-7">
              Atalhos rápidos:
            </div>
            <div class="row q-gutter-xs">
              <template v-if="seletorAvancado.tipo === 'inicio'">
                <q-btn
                  size="sm"
                  outline
                  color="primary"
                  label="Agora"
                  @click="aplicarAtalho('agora')"
                  class="q-px-md"
                />
                <q-btn
                  size="sm"
                  outline
                  color="primary"
                  label="Amanhã 08:00"
                  @click="aplicarAtalho('amanha')"
                  class="q-px-md"
                />
                <q-btn
                  size="sm"
                  outline
                  color="primary"
                  label="Próxima segunda"
                  @click="aplicarAtalho('proximaSemana')"
                  class="q-px-md"
                />
              </template>
              <template v-else>
                <q-btn
                  size="sm"
                  outline
                  color="primary"
                  label="+2h"
                  @click="aplicarAtalho('2horas')"
                  class="q-px-md"
                />
                <q-btn
                  size="sm"
                  outline
                  color="primary"
                  label="+4h"
                  @click="aplicarAtalho('4horas')"
                  class="q-px-md"
                />
                <q-btn
                  size="sm"
                  outline
                  color="primary"
                  label="+8h"
                  @click="aplicarAtalho('8horas')"
                  class="q-px-md"
                />
                <q-btn
                  size="sm"
                  outline
                  color="primary"
                  label="17:00"
                  @click="aplicarAtalho('fimExpediente')"
                  class="q-px-md"
                />
              </template>
            </div>
          </div>

          <q-separator class="q-mb-lg" />

          <div class="text-subtitle2 q-mb-md text-grey-7">Seleção manual:</div>

          <div class="row q-col-gutter-lg">
            <div class="col-12 col-md-7">
              <div class="text-caption q-mb-sm text-grey-6">Data:</div>
              <q-date
                v-model="seletorAvancado.data"
                mask="DD/MM/YYYY"
                :locale="myLocale"
                minimal
                color="primary"
                class="full-width"
              />
            </div>

            <div class="col-12 col-md-5">
              <div class="text-caption q-mb-sm text-grey-6">Hora:</div>
              <div class="flex flex-center">
                <q-time
                  v-model="seletorAvancado.hora"
                  mask="HH:mm"
                  format24h
                  color="primary"
                />
              </div>
            </div>
          </div>
        </q-card-section>

        <q-card-actions align="right" class="q-pt-lg">
          <q-btn
            flat
            color="grey-7"
            label="Cancelar"
            v-close-popup
            class="q-mr-sm"
          />
          <q-btn
            unelevated
            color="primary"
            label="Confirmar"
            @click="confirmarSeletorAvancado"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
import { ref } from "@vue/reactivity";
import { onMounted, watch } from "vue";

import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { useQuasar } from "quasar";
import Map from "../components/Map.vue";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";

export default {
  components: { Map, ListaUnidadesSelect },
  setup() {
    const formatarDataHoraBR = (data) => {
      const dia = String(data.getDate()).padStart(2, "0");
      const mes = String(data.getMonth() + 1).padStart(2, "0");
      const ano = data.getFullYear();
      const hora = String(data.getHours()).padStart(2, "0");
      const minuto = String(data.getMinutes()).padStart(2, "0");
      return `${dia}/${mes}/${ano} ${hora}:${minuto}`;
    };

    const formatarDataHoraAtual = () => {
      const agora = new Date();
      return formatarDataHoraBR(agora);
    };

    const formatarDataHoraFutura = (horas) => {
      const futura = new Date();
      futura.setHours(futura.getHours() + horas);
      return formatarDataHoraBR(futura);
    };

    const emitir = ref({
      unidade: "",
      local: "",
      descricao: "",
      modelo: "",
      dataInicio: formatarDataHoraAtual(),
      dataTermino: formatarDataHoraFutura(2),
      longitude: "",
      latitude: "",
    });
    const dados = ref([]);
    const emitirForm = ref(null);
    const store = useStore();
    const router = useRouter();
    const quasar = useQuasar();
    const geolocalizacao = ref();
    const long = ref();
    const lat = ref();
    const listaArea = ref([]);
    const listaModelos = ref([]);
    let dataValida = new Date();
    const emitirPt = async () => {
      const formValido = await emitirForm.value.validate();
      if (!formValido) {
        return;
      }

      if (!emitir.value.unidade) {
        quasar.notify({
          message: "Selecione uma unidade",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });

        return;
      }

      if (!emitir.value.modelo || !emitir.value.modelo.modeloId) {
        quasar.notify({
          message: "Selecione um modelo",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });

        return;
      }

      const inicio = formatarDataHora(emitir.value.dataInicio);
      const termino = formatarDataHora(emitir.value.dataTermino);
      if (inicio < dataValida || termino < dataValida) {
        quasar.notify({
          message: "Data invalida",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }

      try {
        const dataInicio = formatarDataHora(emitir.value.dataInicio);
        const dataTermino = formatarDataHora(emitir.value.dataTermino);
        const resposta = await store.dispatch("pdt/emitirPt", {
          unidadeId: emitir.value.unidade.id,
          modeloId: emitir.value.modelo.modeloId,
          local: emitir.value.local.nome,
          descricao: emitir.value.descricao,
          dataHoraInicio: dataInicio,
          dataHoraTermino: dataTermino,
          latitude: emitir.value.latitude,
          longitude: emitir.value.longitude,
          areaTrabalho: dados.value.areaTrabalho,
          observacao: dados.value.observacao,
          recomendacao: dados.value.recomendacao,
          outrasMedidas: dados.value.outrasMedidas,
          aviso: dados.value.aviso,
        });

        const ptId = resposta.data.resultado.id;
        quasar.notify({
          message: `Permissão trabalho [${ptId}] emitida com sucesso`,
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });

        redirecionarDetalhePt(ptId);
      } catch (error) {
        let message = "Erro ao emitir permissão de trabalho";
        if (error.response) {
          message = error.response.data.erros.Mensagem;
        }
        quasar.notify({
          message,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const parsearDataHora = (valor) => {
      const regex = /^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2})$/;
      const match = valor.match(regex);

      if (!match) return null;

      const [, dia, mes, ano, hora, minuto] = match;
      return new Date(ano, mes - 1, dia, hora, minuto);
    };

    const validarDataHora = (valor) => {
      if (!valor) return false;

      const regex = /^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2})$/;
      const match = valor.match(regex);

      if (!match) return false;

      const [, dia, mes, ano, hora, minuto] = match;
      const data = new Date(ano, mes - 1, dia, hora, minuto);

      return (
        data.getDate() == dia &&
        data.getMonth() == mes - 1 &&
        data.getFullYear() == ano &&
        data.getHours() == hora &&
        data.getMinutes() == minuto
      );
    };

    const validarDataTermino = (valor) => {
      if (!valor || !emitir.value.dataInicio) return true;

      const dataInicio = parsearDataHora(emitir.value.dataInicio);
      const dataTermino = parsearDataHora(valor);

      if (!dataInicio || !dataTermino) return true;

      return dataTermino > dataInicio;
    };

    const ajustarDataTermino = () => {
      const dataInicio = parsearDataHora(emitir.value.dataInicio);
      if (!dataInicio) return;

      const dataTermino = new Date(dataInicio);
      dataTermino.setHours(dataTermino.getHours() + 2);

      emitir.value.dataTermino = formatarDataHoraBR(dataTermino);
    };

    const seletorAvancado = ref({
      aberto: false,
      tipo: "",
      data: "",
      hora: "",
    });

    const abrirSeletorAvancado = (tipo) => {
      seletorAvancado.value.tipo = tipo;
      seletorAvancado.value.aberto = true;

      const valorAtual =
        tipo === "inicio" ? emitir.value.dataInicio : emitir.value.dataTermino;
      const dataAtual = parsearDataHora(valorAtual);

      if (dataAtual) {
        seletorAvancado.value.data =
          formatarDataHoraBR(dataAtual).split(" ")[0];
        seletorAvancado.value.hora = `${String(dataAtual.getHours()).padStart(
          2,
          "0"
        )}:${String(dataAtual.getMinutes()).padStart(2, "0")}`;
      } else {
        const agora = new Date();
        seletorAvancado.value.data = formatarDataHoraBR(agora).split(" ")[0];
        seletorAvancado.value.hora = `${String(agora.getHours()).padStart(
          2,
          "0"
        )}:${String(agora.getMinutes()).padStart(2, "0")}`;
      }
    };

    const aoAlterarData = () => {
      const agora = new Date();
      seletorAvancado.value.hora = `${String(agora.getHours()).padStart(
        2,
        "0"
      )}:${String(agora.getMinutes()).padStart(2, "0")}`;
    };

    const confirmarSeletorAvancado = () => {
      const dataHoraCompleta = `${seletorAvancado.value.data} ${seletorAvancado.value.hora}`;

      if (seletorAvancado.value.tipo === "inicio") {
        emitir.value.dataInicio = dataHoraCompleta;
        ajustarDataTermino();
      } else {
        emitir.value.dataTermino = dataHoraCompleta;
      }

      seletorAvancado.value.aberto = false;
    };

    const aplicarAtalho = (tipo) => {
      let dataCalculada;

      if (seletorAvancado.value.tipo === "inicio") {
        const agora = new Date();

        switch (tipo) {
          case "agora":
            dataCalculada = agora;
            break;
          case "amanha": {
            const amanha = new Date();
            amanha.setDate(amanha.getDate() + 1);
            amanha.setHours(8, 0, 0, 0);
            dataCalculada = amanha;
            break;
          }
          case "proximaSemana": {
            const proximaSegunda = new Date();
            const diasAteSegunda = (1 + 7 - proximaSegunda.getDay()) % 7 || 7;
            proximaSegunda.setDate(proximaSegunda.getDate() + diasAteSegunda);
            proximaSegunda.setHours(8, 0, 0, 0);
            dataCalculada = proximaSegunda;
            break;
          }
        }
      } else {
        const dataInicio = parsearDataHora(emitir.value.dataInicio);
        if (!dataInicio) return;

        dataCalculada = new Date(dataInicio);

        switch (tipo) {
          case "2horas":
            dataCalculada.setHours(dataCalculada.getHours() + 2);
            break;
          case "4horas":
            dataCalculada.setHours(dataCalculada.getHours() + 4);
            break;
          case "8horas":
            dataCalculada.setHours(dataCalculada.getHours() + 8);
            break;
          case "fimExpediente":
            dataCalculada.setHours(17, 0, 0, 0);
            if (dataInicio.getHours() >= 17) {
              dataCalculada.setDate(dataCalculada.getDate() + 1);
            }
            break;
        }
      }

      if (dataCalculada) {
        seletorAvancado.value.data =
          formatarDataHoraBR(dataCalculada).split(" ")[0];
        seletorAvancado.value.hora = `${String(
          dataCalculada.getHours()
        ).padStart(2, "0")}:${String(dataCalculada.getMinutes()).padStart(
          2,
          "0"
        )}`;
      }
    };

    const redirecionarDetalhePt = (ptId) => {
      router.push({ name: "pdt-pt-detalhe", params: { ptId } });
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        if (store.state.org.unidadeData == null) {
          return;
        }

        emitir.value.unidade = store.state.org.unidadeData;
        checarStatusLocalizacao();
        listarArea();
        listarModelos();
      }
    );

    watch(
      () => emitir.value.unidade,
      () => {
        if (emitir.value.unidade?.id) {
          listarModelos();
          emitir.value.modelo = null;
        }
      }
    );

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        emitir.value.unidade = JSON.parse(getunidade);
        receberAtividades();
        checarStatusLocalizacao();
      }
    };

    const buscaCordenadas = (position) => {
      long.value = position.coords.longitude;
      lat.value = position.coords.latitude;
      let longitude = position.coords.longitude.toString();
      let latitude = position.coords.latitude.toString();
      emitir.value.longitude = longitude;
      emitir.value.latitude = latitude;
    };
    const erroBuscaCordenadas = (erro) => {
      console.log(erro);
    };

    const recebeGeolocalizacao = () => {
      navigator.geolocation.getCurrentPosition(
        buscaCordenadas,
        erroBuscaCordenadas,
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 1000,
        }
      );
    };

    const checarStatusLocalizacao = async () => {
      let resposta = await store.dispatch("pdt/checarStatusGeolocalizacao", {
        unidadeId: emitir.value.unidade.id,
      });
      geolocalizacao.value = resposta.data.resultado.ativo;
      if (geolocalizacao.value) {
        recebeGeolocalizacao();
      }
    };

    const receberAtividades = async () => {
      dados.value = {
        areaTrabalho: "",
        observacao: "",
        recomendacao: "",
        outrasMedidas: "",
        aviso: "",
      };
      try {
        let resposta = await store.dispatch(
          "pdt/receberConfiguraçõesInformacao",
          {
            unidadeId: emitir.value.unidade.id,
          }
        );

        if (resposta.data.resultado.dados != null) {
          dados.value = resposta.data.resultado.dados;
        }
      } catch (error) {
        console.log(error);
      }
    };

    const dataAtual = () => {
      let hoje = new Date();

      let ontem = new Date(hoje.getTime());
      ontem.setDate(hoje.getDate());

      let dd = ontem.getDate();
      let mm = ontem.getMonth() + 1;
      let yyyy = ontem.getFullYear();

      if (dd < 10) {
        dd = "0" + dd;
      }

      if (mm < 10) {
        mm = "0" + mm;
      }

      let data_valida = yyyy + "/" + mm + "/" + dd;
      dataValida = data_valida;
    };

    let listarArea = async () => {
      await emitir.value.unidade.id;
      try {
        let response = await store.dispatch("area/listar", {
          unidadeId: emitir.value.unidade.id,
        });
        listaArea.value = response.listaArea;
      } catch (error) {
        console.error(error);
      }
    };

    const listarModelos = async () => {
      if (!emitir.value.unidade?.id) return;

      try {
        const response = await store.dispatch("pdt/listarModelos", {
          unidadeId: emitir.value.unidade.id,
        });
        listaModelos.value = response.data.resultado.dados || [];
      } catch (error) {
        console.error("Erro ao listar modelos:", error);
        listaModelos.value = [];
      }
    };

    onMounted(getUnidade);
    onMounted(dataAtual);
    onMounted(listarArea);

    watch(
      () => seletorAvancado.value.data,
      (novaData) => {
        if (novaData && seletorAvancado.value.aberto) {
          const agora = new Date();
          seletorAvancado.value.hora = `${String(agora.getHours()).padStart(
            2,
            "0"
          )}:${String(agora.getMinutes()).padStart(2, "0")}`;
        }
      }
    );

    const formatarDataHora = (valor) => {
      const regex = /^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2})$/;
      const match = valor.match(regex);

      if (match) {
        const [, dia, mes, ano, hora, minuto] = match;
        return `${ano}/${mes}/${dia} ${hora}:${minuto}:00`;
      }

      if (valor.includes(" ")) {
        let hora = valor.split(" ")[1];
        let data = valor.split(" ")[0].split("/").reverse().join("/");
        return `${data} ${hora}`;
      }

      return valor;
    };

    return {
      emitir,
      emitirForm,
      emitirPt,
      getUnidade,
      validarDataHora,
      validarDataTermino,
      ajustarDataTermino,
      aoAlterarData,
      seletorAvancado,
      abrirSeletorAvancado,
      confirmarSeletorAvancado,
      aplicarAtalho,
      myLocale: {
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      recebeGeolocalizacao,
      checarStatusLocalizacao,
      geolocalizacao,
      lat,
      long,
      dados,
      receberAtividades,
      dataValida,
      dataAtual,
      listarArea,
      listarModelos,
      listaArea,
      listaModelos,
    };
  },
};
</script>

<style scoped>
.btn-emitir {
  margin-top: 6px;
}

@media (max-width: 600px) {
  .titulo-pagina {
    font-size: 14px;
    margin-top: 10px;
  }

  .container-input {
    margin: 0px 16px !important;
    gap: 16px !important;
  }

  .col-md-3.col-sm-5.col-xs-5,
  .col-md-3.col-sm-6.col-xs-6,
  .col-md-3.col-xs-5.col-sm-5.col-lg-3,
  .col-lg-5.col-md-5.col-sm-6.col-xs-6,
  .col-lg-2.col-md-3.col-sm-5.col-xs-5 {
    flex: 0 0 100% !important;
    max-width: 100% !important;
    margin-bottom: 16px !important;
  }

  .titulo-input {
    margin: 0px 0px 6px 8px;
    font-size: 12px;
    font-weight: 600;
    color: #21324a;
  }

  .select {
    font-size: 16px !important;
  }

  .input {
    font-size: 16px !important;
  }

  .icon {
    font-size: 18px;
  }

  .btn-emitir {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
    font-size: 13px;
    width: 100% !important;
    min-height: 44px !important;
  }

  .btn-emitir p {
    display: none;
  }
}

@media (max-width: 480px) {
  .titulo-pagina {
    font-size: 18px;
    margin-top: 8px;
  }

  .container-input {
    margin: 0px 12px !important;
    gap: 1px !important;
  }

  .col-md-3.col-sm-5.col-xs-5,
  .col-md-3.col-sm-6.col-xs-6,
  .col-md-3.col-xs-5.col-sm-5.col-lg-3,
  .col-lg-5.col-md-5.col-sm-6.col-xs-6,
  .col-lg-2.col-md-3.col-sm-5.col-xs-5 {
    margin-bottom: 4px !important;
  }

  .titulo-input {
    margin: 0px 0px 4px 6px;
    margin-left: -5px;
    font-size: 15px;
  }

  .select {
    font-size: 16px !important;
    margin-left: -8px;
  }

  .input {
    font-size: 16px !important;
    margin-left: -8px;
  }

  .btn-emitir {
    font-size: 12px;
    min-height: 42px !important;
  }

  .titulo-input-mobile {
    margin-left: -8px;
  }

  .titulo-input-mobile-margin {
    margin-top: -14px;
  }

  .btn-emitir {
    margin-left: -5px;
  }
}

@media (max-width: 360px) {
  .titulo-pagina {
    font-size: 12px;
    margin-top: 6px;
  }

  .container-input {
    margin: 0px 8px !important;
    gap: 12px !important;
  }

  .col-md-3.col-sm-5.col-xs-5,
  .col-md-3.col-sm-6.col-xs-6,
  .col-md-3.col-xs-5.col-sm-5.col-lg-3,
  .col-lg-5.col-md-5.col-sm-6.col-xs-6,
  .col-lg-2.col-md-3.col-sm-5.col-xs-5 {
    margin-bottom: 12px !important;
  }

  .titulo-input {
    margin: 0px 0px 3px 4px;
    font-size: 10px;
  }

  .select {
    font-size: 16px !important;
  }

  .input {
    font-size: 16px !important;
  }

  .btn-emitir {
    font-size: 11px;
    min-height: 40px !important;
  }
}

.q-field--outlined .q-field__control:before {
  border-color: #e0e0e0;
}

.q-field--outlined.q-field--focused .q-field__control:before {
  border-color: #1976d2;
  border-width: 2px;
}

.q-btn-dropdown {
  min-width: auto;
}

.q-item__label--caption {
  font-size: 11px;
  opacity: 0.7;
}

.q-date {
  box-shadow: none;
}

.q-time {
  box-shadow: none;
}

@media (max-width: 768px) {
  .q-date {
    width: 100% !important;
  }

  .q-time {
    width: 100% !important;
    margin: 0 auto;
  }
}

.q-btn.outline {
  border: 1px solid currentColor;
}

.q-date.full-width {
  width: 100%;
  max-width: 100%;
}
</style>
